module.exports = __webpack_public_path__ + "img/undressed-woman-2.4d771823.jpg";